import { useEffect } from "react";
import DINDORF from '../../assets/image19.jpeg';
import ContactFloating from "../../components/contact-floating";
import CountUp from 'react-countup';
import './Nosotros.styles.scss';

const Nosotros = () => {
    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="nosotros-page">
            <section className="nosotros-hero section animate__animated animate__fadeIn">
                <div className="md:max-w-[1600px] max-w-[90%] mx-auto md:w-[100%] h-[400px] md:h-[500px] lg:h-[600px]">
                    <img
                        src={DINDORF}
                        alt="imgDindorf"
                        className="object-cover object-center w-full h-full rounded-lg"
                    />
                </div>

                <div className="flex flex-wrap max-w-2xl pl-2 pr-2 mx-auto mt-8 text-center text-gray-700 animate_animated animate__slideInUp animate__delay-2s md:container md:pl-0 md:pr-0">
                    <h1 className="text-3xl w-full flex-[100%] font-bold text-black md:text-4xl lg:text-5xl mb-6">
                        Nuestra Historia
                    </h1>
                    <div className="flex flex-col items-start justify-center lg:flex-row">
                        <div className="flex flex-col justify-between h-full px-4 leading-8 text-black lg:w-1/2">
                            <p className="mt-4 mb-4 text-black">
                                La historia de Dindorf comienza en 1966, pero nuestra pasión por la mecánica se remonta aún más atrás. 
                                En 1959, nuestro padre, Sebastian Carlos Dindorf, o mejor conocido como "kuki", se convirtió en uno de 
                                los mecánicos de motos más reconocidos del departamento, destacándose por su dedicación, experiencia y voluntad. 
                                Años más tarde, dimos un paso decisivo en nuestra historia al adquirir el terreno ubicado en calle Vicuña Prado, 
                                lugar que hoy alberga a Dindorf Servicio y Venta Automotor. Este hito marcó el inicio de una nueva etapa, 
                                que nos permitió crecer, consolidarse y proyectarse hacia el futuro.  
                                Desde entonces, hemos evolucionado constantemente, adaptándonos a los cambios y desafíos del sector automotor, 
                                pero sin perder jamás la esencia que nos distingue desde el primer día: el compromiso con nuestros clientes, 
                                la pasión por lo que hacemos y la búsqueda constante de la calidad y la confianza en cada servicio y venta.
                            </p>
                            <a
                                href="https://wa.me/5492634588256?text=Hola,%20quisiera%20consultar%20sobre%20sus%20servicios"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="p-4 mb-4 text-xl text-gray-900 rounded-lg md:mr-6 md:text-3xl bg-slate-200 md:p-8"
                            >
                                Contáctanos
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sección de estadísticas */}
            <section className="stats-section section">
                <div className="container stats-container">
                    <div className="stats-card">
                        <h3 className="stats-title">
                            <CountUp
                                start={0}
                                end={2500}
                                duration={3}
                                prefix="+"
                            />
                        </h3>
                        <p className="stats-description">Vehículos reparados!</p>
                    </div>
                </div>
            </section>

            <ContactFloating />
        </div>
    );
};

export default Nosotros;